import React, { memo } from "react";

export const DraggableLabel = memo(({ title, value }) => {
    return (
        <p className="p-l-12">
            <span className="txt-bold">{title}: </span>
            {value}
        </p>
    );
});
